/*
 * @Description: 
 * @version: 
 * @Author: 小六
 * @Date: 2022-04-06 11:33:31
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-06-30 11:24:27
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from './router'
import BaiduMap from 'vue-baidu-map'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'babel-polyfill'
import axios from 'axios';
import store from './store'
import 'font-awesome/css/font-awesome.min.css'
/*引入资源请求插件*/
import VueResource from 'vue-resource'
import { mapGetters } from "vuex";


/*使用VueResource插件*/
Vue.use(VueResource)
Vue.prototype.$axios = axios

Vue.use(BaiduMap, {
  ak: '0PpI7FFHCcbjFzwd59FRGsjQTdmYe18G'
});
Vue.use(ElementUI);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store,
  template: '<App/>',

  computed: {
    ...mapGetters({
      meta_all: "meta_all"
      // organization_id_me: "organization_id_me",
      // search_index: "search_index"
    })
  },
  watch: {
    meta_all: {
      handler(newVal, oldVal) {
        console.log('oldVal:', oldVal)
        console.log('newVal:', newVal)
        this.setMeta()
      },
      // 立即处理 进入页面就触发
      // immediate: true,
      // 深度监听 属性的变化
      deep: true
    }
  },
  methods: {
    setMeta() {
      document.querySelector('meta[name="keywords"]').setAttribute('content', this.meta_all.keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', this.meta_all.description)
    }
  }
},

)



// WEBPACK FOOTER //
// ./src/main.js